<template lang="pug">
include /@ibkr/lib.common/src/icon/color
include /@ibkr/lib.common/src/icon/basic
div(class="border-bottom product-select")
    ib-row(:class="{ 'pb-16': !$media.xl }")
        ib-col(class="xl3 s12", :class="{'after-16': !$media.xl}")
            p(:class="{'insety-4': $media.xl, 'insetx-8': $media.xl}")
                span(
                    class="insetx-4 info",
                    :class="{'start-0': !$media.m}"
                )
                    +icon-basic-info_filled
                    span(class="tooltext") {{ $t('select_product_type') }}
                span {{ $t('product_type') }}
        ib-col(
            class="flex xl9 pb-0 flex-change",
            :class="{'insetx-0': !$media.m }"
        )
            ib-button(
                @click="setAllActive",
                class="text-bold after-4 text-left"
            ) {{ $t('select_all') }}
                span(
                    v-if="selectAll",
                    class="inset-8 fg-positive",
                )
                    +icon-color-yes
            ib-button(
                v-for="(product, index) in products.slice(0,2)",
                :key="index",
                class="after-4 text-left",
                @click="select(index)",
                :class="{}"
            )
                span {{ $t(product.name) }}
                span(
                    v-if="product.selected",
                    class="inset-8 fg-positive"
                )
                    +icon-color-yes
        ib-col(
            class="flex xl9 offset-xl3 pb-0 flex-change",
            :class="{ 'insetx-0': !$media.m, 'insety-4': $media.s}"
        )
            ib-button(
                v-for="(product, index) in products.slice(2,5)",
                :key="index",
                class="after-4 text-left",
                @click="select(index+2)",
                :class="{}"
            )
                span {{ $t(product.name) }}
                span(
                    v-if="product.selected",
                    class="inset-8 fg-positive"
                )
                    +icon-color-yes
        ib-col(
            class="flex xl9 offset-xl3 pb-0 flex-change",
            :class="{ 'insetx-0': !$media.m, 'insety-4': $media.s }"
        )
            ib-button(
                v-for="(product, index) in products.slice(5,8)",
                :key="index",
                class="after-4 text-left",
                @click="select(index+5)",
                :class="{}"
            )
                span {{ $t(product.name) }}
                span(
                    v-if="product.selected",
                    class="inset-8 fg-positive"
                )
                    +icon-color-yes
        ib-col(
            class="flex xl9 offset-xl3 pb-0 flex-change",
            :class="{ 'insetx-0': !$media.m, 'insety-4': $media.s }"
        )
            ib-button(
                v-for="(product, index) in products.slice(8,11)",
                :key="index",
                class="after-4 text-left",
                @click="select(index+8)",
                :class="{}"
            )
                span {{ $t(product.name) }}
                span(
                    v-if="product.selected",
                    class="inset-8 fg-positive"
                )
                    +icon-color-yes
        ib-col(
            class="flex xl9 offset-xl3 pb-0 flex-change",
            :class="{ 'insetx-0': !$media.m, 'insety-4': $media.s }"
        )
            ib-button(
                v-for="(product, index) in products.slice(11,13)",
                :key="index",
                class="after-4 text-left",
                @click="select(index+11)",
                :class="{}"
            )
                span {{ $t(product.name) }}
                span(
                    v-if="product.selected",
                    class="inset-8 fg-positive"
                )
                    +icon-color-yes

</template>

<script>
    import cloneDeep from 'lodash.clonedeep';
    import { mapState, mapActions, mapGetters } from 'vuex';

    export default {
        name: 'ProductType',
        data() {
            return {
            }
        },
        mounted() {
            let pdts = [];
            this.domains.map(domain => {
                if(this.selectedDomain === domain.domainName) {
                    this.productTypes.map(type => {
                        if(domain.allowedProductTypes.includes(type.name)){
                            pdts.push(type);
                        }
                    })
                }
            })
            this.setProductTypes(pdts);
        },
        methods: {
            select(index) {
                const productType = cloneDeep(this.productTypes[index]);
                productType.selected = !productType.selected;
                let typeIndex = this.searchProductType.indexOf(productType.symbol);
                if(typeIndex > -1){
                    this.$store.commit('removeSearchProductType', productType.symbol);
                } else {
                    if(productType.selected){
                        this.$store.commit('setSearchProductType', productType.symbol);
                    }
                }
                this.setProductType({index, productType: productType});
            },
            setAllActive() {
                let all = cloneDeep(this.productTypes);
                if (this.selectAll) {
                    all.forEach(item => item.selected = false);
                    this.$store.commit('setSearchProductType', []);
                } else {
                    all.forEach(item => item.selected = true);
                    all.filter(type => {
                        this.$store.commit('setSearchProductType', type.symbol);
                    })
                }
                this.setProductTypes(all);
            },
            ...mapActions(['setProductType', 'setProductTypes', 'setSearchProductType'])
        },
        computed: {
            products: function() {
                return this.productTypes.filter(product => product.name);
            },
            selectAll: function() {
                return this.productTypes.filter(product => product.selected).length === this.productTypes.length;
            },
            ...mapGetters(['selectedDomain']),
            ...mapState(['productTypes', 'regions', 'countries', 'searchProductType', 'domains'])
        },
    }
</script>

<style lang="less">
.product-select {
    padding-top: 32px;
    padding-bottom: 16px;
    .pb-16 {
        padding-bottom: 16px;
    }
    .pb-0 {
        padding-bottom: 0;
    }
    .flex-change {
        flex-direction: row;
        flex-basis: 75%;
        justify-content: flex-start;
        flex-wrap: wrap;
        button {
            width: 32%;
            border-radius: 0;
            &::after {
                background-color: white;
            }
            svg {
                float: right;
            }
            &:hover {
                border-color: #000;
                span {
                    color: #000;
                }
            }
        }
    }
}

@media (max-width: 991px) {
    .product-select {
        padding-top: 16px;
        .flex-change {
            flex-basis: 100%;
            button {
                width: 100%;
                margin-top: 2px;
                margin-bottom: 8px;
            }
        }
    }
}
</style>